import React, { useEffect } from 'react'
import Price from 'components/Price'
import IconCencosudCard from 'components/IconCencosudCard'
import PropTypes from 'prop-types'

const maxAmount = 3000000
const alertAmount = maxAmount - 50000

const Totals = (props) => {
    const { totalizers, alertAmount: alertAmountCallback } = props

    if (!totalizers) return ''

    const getValue = (id) => {
        const items = totalizers.filter((item) => item.id === id)
        return items[0] ? Math.abs(items[0].value) : 0
    }

    const discount = getValue('Discounts')
    const subTotal = getValue('Items') - discount
    const tcenco = getValue('Tcenco')

    useEffect(() => {
        const totalAmount = subTotal / 100

        if (totalAmount >= alertAmount && totalAmount < maxAmount) {
            alertAmountCallback(maxAmount, false, true)
        } else if (totalAmount >= maxAmount) {
            alertAmountCallback(maxAmount, true, false)
        } else {
            alertAmountCallback(maxAmount, false, false)
        }
    }, [totalizers])

    return (
        <div className="minicartcontent-totals">
            {tcenco < subTotal && (
                <div className="minicartcontent-subtotal tcenco">
                    <span className="text">Subtotal T. Cencosud Scotiabank</span>
                    <span className="price">
                        <IconCencosudCard />
                        <Price price={tcenco / 100} />
                    </span>
                </div>
            )}
            <div className="minicartcontent-subtotal">
                <span className="text">Subtotal {tcenco < subTotal ? 'otro medio de pago' : ''}</span>
                <span className="price">
                    <Price price={subTotal / 100} />
                </span>
            </div>
        </div>
    )
}

Totals.propTypes = {
    totalizers: PropTypes.array,
    alertAmount: PropTypes.func,
}

export default Totals
